import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useCallback } from 'react';
import { View, Text, TextInput } from 'react-native';
import styled from 'styled-components/native';
import SccPressable from '@/components/SccPressable';
import SccRemoteImage from '@/components/SccRemoteImage';
import { color } from '@/constant/color';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import HtmlContentWrapper from '../components/HtmlContentWrapper';
import ImageUploader from '../components/ImageUploader';
import { useEditMode } from '../context/EditModeContext';
import { useResponsive } from '../context/ResponsiveContext';
export default function TicketInfoSection({ ticketInfoSection, sectionId, }) {
    var _a;
    const editContext = useEditMode();
    const isEditMode = (_a = editContext === null || editContext === void 0 ? void 0 : editContext.isEditMode) !== null && _a !== void 0 ? _a : false;
    const { isDesktop } = useResponsive();
    const { titleLine1, titleLine2, descriptionHtml, imageUrl, mobileImageUrl } = ticketInfoSection;
    // 데스크탑이 아니면 모바일 이미지 우선 사용
    const displayImageUrl = isDesktop ? imageUrl : (mobileImageUrl || imageUrl);
    const updateTicketInfoSection = useCallback((updates) => {
        if (!editContext)
            return;
        editContext.updateData((prev) => (Object.assign(Object.assign({}, prev), { ticketInfoSection: prev.ticketInfoSection
                ? Object.assign(Object.assign({}, prev.ticketInfoSection), updates) : null })));
    }, [editContext]);
    const handleTitleLine1Change = useCallback((text) => {
        updateTicketInfoSection({ titleLine1: text });
    }, [updateTicketInfoSection]);
    const handleTitleLine2Change = useCallback((text) => {
        updateTicketInfoSection({ titleLine2: text });
    }, [updateTicketInfoSection]);
    const handleImageChange = useCallback((url) => {
        updateTicketInfoSection({ imageUrl: url });
    }, [updateTicketInfoSection]);
    return (_jsx(LogParamsProvider, { params: { displaySectionName: '매표정보' }, children: _jsx("div", { id: sectionId, children: _jsx(Container, { isDesktop: isDesktop, children: _jsxs(ContentWrapper, { isDesktop: isDesktop, children: [_jsx(TitleSection, { children: isEditMode ? (_jsxs(_Fragment, { children: [_jsx(TitleLine1Input, { value: titleLine1, onChangeText: handleTitleLine1Change, placeholder: "\uD0C0\uC774\uD2C0 1\uC904 (\uAC80\uC815)", placeholderTextColor: color.gray40, isDesktop: isDesktop }), _jsx(TitleLine2Input, { value: titleLine2, onChangeText: handleTitleLine2Change, placeholder: "\uD0C0\uC774\uD2C0 2\uC904 (\uD30C\uB791)", placeholderTextColor: color.gray40, isDesktop: isDesktop })] })) : (_jsxs(_Fragment, { children: [_jsx(TitleLine1, { isDesktop: isDesktop, children: titleLine1 }), _jsx(TitleLine2, { isDesktop: isDesktop, children: titleLine2 })] })) }), _jsxs(ContentRow, { isDesktop: isDesktop, children: [descriptionHtml && (_jsx(DescriptionWrapper, { isDesktop: isDesktop, children: _jsx(HtmlContentWrapper, { isDesktop: isDesktop, children: _jsx("div", { dangerouslySetInnerHTML: { __html: descriptionHtml } }) }) })), displayImageUrl ? (_jsxs(ImageContainer, { isDesktop: isDesktop, children: [_jsx(SccPressable, { onPress: () => { }, elementName: "bbucle-road-ticket-info-image-click", trackView: true, logParams: { imageUrl: displayImageUrl }, disableLogging: isEditMode, children: _jsx(SccRemoteImage, { imageUrl: displayImageUrl, resizeMode: "contain", style: { borderRadius: 12 } }) }), isEditMode && (_jsx(ImageOverlay, { children: _jsx(ImageUploader, { currentImageUrl: imageUrl, onUploadComplete: handleImageChange, compact: true }) }))] })) : (isEditMode && (_jsxs(EmptyImagePlaceholder, { isDesktop: isDesktop, children: [_jsx(EmptyImageText, { children: "\uB9E4\uD45C\uC18C \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD558\uC138\uC694" }), _jsx(ImageUploader, { onUploadComplete: handleImageChange, buttonText: "\uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" })] })))] })] }) }) }) }));
}
const Container = styled(View) `
  padding-vertical: ${({ isDesktop }) => (isDesktop ? '140px' : '80px')};
  width: 100%;
  background-color: ${color.gray10};
`;
const ContentWrapper = styled(View) `
  align-items: center;
  gap: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  width: 100%;
  padding: 0 16px;
`;
const TitleSection = styled(View) `
  align-items: center;
  gap: 0;
  max-width: 800px;
  width: 100%;
  padding: 0 16px;
`;
const ContentRow = styled(View) `
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column-reverse')};
  gap: ${({ isDesktop }) => (isDesktop ? '30px' : '40px')};
  max-width: 1020px;
  width: 100%;
  align-items: ${({ isDesktop }) => (isDesktop ? 'flex-start' : 'center')};
`;
const DescriptionWrapper = styled(View) `
  flex: ${({ isDesktop }) => (isDesktop ? '2' : 'none')};
  width: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
`;
const TitleLine1 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine2 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine1Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  width: 100%;
`;
const TitleLine2Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  width: 100%;
`;
const ImageContainer = styled(View) `
  flex: ${({ isDesktop }) => (isDesktop ? '3' : 'none')};
  width: ${({ isDesktop }) => (isDesktop ? 'auto' : 'calc(100% + 32px)')};
  margin-horizontal: ${({ isDesktop }) => (isDesktop ? '0' : '-16px')};
  position: relative;
`;
const ImageOverlay = styled(View) `
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
`;
const EmptyImagePlaceholder = styled(View) `
  flex: ${({ isDesktop }) => (isDesktop ? '1' : 'none')};
  width: ${({ isDesktop }) => (isDesktop ? 'auto' : '100%')};
  padding: 60px;
  background-color: ${color.white};
  border: 2px dashed ${color.gray25};
  border-radius: 12px;
  align-items: center;
  gap: 16px;
`;
const EmptyImageText = styled(Text) `
  font-size: 16px;
  color: ${color.gray60};
`;
